<script>
	export default {
		name: 'SalesExecuter',
		methods: {
			getSalesByMerchantId(merchantId) {
				const self_ = this;

				let merchant_ = {}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreDocument('sales', merchantId)
					}).then(result => {
						if(!self_.isEmpty(result)) { 
							merchant_[merchantId] = result; 
						} else {
							merchant_.dummy = self_.getSalesState('dummy')
						}

						if(self_.isEmpty(merchant_[merchantId])) { resolve(merchant_) }
						
						return self_.getFirestoreSubCollection('sales', merchantId, 'products')
					}).then(result => {
						if(!self_.isEmpty(result)) { 
							merchant_[merchantId].products = result;
						}
						resolve(merchant_)
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: getSalesByMerchantId(' + merchantId + ') -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			getSalesByMerchantIdAndProductId(merchantId, productId) {
				const self_ = this;

				return self_.getFirestoreSubSubCollection('sales', merchantId, 'products', productId, 'serialNumbers')
			}
		}
	}
</script>